import { useState } from "react";
import Header from "./Header";
import { useLocation } from "react-router-dom";

function UpdateProfile() {
  const location = useLocation();
  const { profile } = location.state || {};

  const [formData, setFormData] = useState({
    profileFor: profile?.profileFor || "",
    gender: profile?.gender || "",
    name: profile?.name || "",
    email: profile?.email || "",
    mobile: profile?.mobile || "",
    dob: profile?.profile?.dob
      ? new Date(profile.profile.dob).toISOString().split("T")[0]
      : "",
    maritalStatus: profile?.profile?.maritalStatus || "",
    religion: profile?.profile?.religion || "",
    diet: profile?.profile?.diet || "",
  });

  const [originalData] = useState(formData);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const getChangedFields = () => {
    const changed = {};
    const profileChanges = {};

    for (const key in formData) {
      const newValue = formData[key];
      const oldValue = originalData[key];

      if (newValue !== oldValue) {
        if (key === "dob") {
          profileChanges["dob"] = new Date(newValue).getTime();
        } else if (["maritalStatus", "religion", "diet"].includes(key)) {
          profileChanges[key] = newValue;
        } else {
          changed[key] = newValue;
        }
      }
    }

    if (!changed.mobile) {
      changed.mobile = formData.mobile;
    }

    if (Object.keys(profileChanges).length > 0) {
      changed.profile = profileChanges;
    }

    return changed;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = getChangedFields();

    if (Object.keys(payload).length === 0) {
      alert("No changes detected.");
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const res = await fetch(
        "https://xqk5c9abna.execute-api.ap-south-1.amazonaws.com/prod/profile/EditProfile",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (res.ok) {
        window.history.back();
      } else {
        const err = await res.json();
        alert("Error: " + err.message);
      }
    } catch (error) {
      console.error("Update failed:", error);
      alert("Something went wrong.");
    }
  };

  return (
    <>
      <Header />
      <div className="container py-3">
        <h3 className="m-0 lh-sm">
          Update Profile &mdash; {profile?.name || "User"}{" "}
          <span className="text-secondary">({profile?.userId})</span>
        </h3>
        <p className="mb-5 text-danger">
          ⚠️ Please check all profile details before submitting. You can update
          them anytime later if needed.
        </p>

        <form
          onSubmit={handleSubmit}
          className="col-lg-7 col-12 row g-2 bg-light p-4 rounded-4"
        >
          <div className="col-6">
            <label className="form-label mb-1 mt-0">Profile For</label>
            <select
              name="profileFor"
              className="form-control"
              value={formData.profileFor}
              onChange={handleChange}
            >
              <option>Self</option>
              <option>Son</option>
              <option>Daughter</option>
              <option>Brother</option>
              <option>Sister</option>
              <option>Friend</option>
              <option>Relative</option>
            </select>
          </div>

          <div className="col-6">
            <label className="form-label mb-1 mt-0">Gender</label>
            <select
              name="gender"
              className="form-control"
              value={formData.gender}
              onChange={handleChange}
            >
              <option>Male</option>
              <option>Female</option>
            </select>
          </div>

          <div className="col-6">
            <label className="form-label mb-1 mt-0">Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter Name"
              className="form-control"
              required
            />
          </div>

          <div className="col-6">
            <label className="form-label mb-1 mt-0">Email ID</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter Email ID"
              className="form-control"
            />
          </div>

          <div className="col-6">
            <label className="form-label mb-1 mt-0">Mobile No</label>
            <input
              type="text"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              placeholder="Enter Mobile No"
              className="form-control"
              required
              readOnly
            />
          </div>

          <div className="col-6">
            <label className="form-label mb-1 mt-0">Date Of Birth</label>
            <input
              type="date"
              name="dob"
              value={formData.dob}
              onChange={handleChange}
              className="form-control"
              required
            />
          </div>

          <div className="col-6">
            <label className="form-label mb-1 mt-0">Marital Status</label>
            <select
              name="maritalStatus"
              value={formData.maritalStatus}
              onChange={handleChange}
              className="form-control"
            >
              <option>Never Married</option>
              <option>Awaiting Divorce</option>
              <option>Divorced</option>
              <option>Widowed</option>
              <option>Annulled</option>
            </select>
          </div>

          <div className="col-6">
            <label className="form-label mb-1 mt-0">Religion</label>
            <select
              name="religion"
              value={formData.religion}
              onChange={handleChange}
              className="form-control"
            >
              <option>Hindu</option>
              <option>Muslim</option>
              <option>Christian</option>
              <option>Buddhist</option>
              <option>Sikh</option>
              <option>Jain</option>
              <option>Other</option>
            </select>
          </div>

          <div className="col-6">
            <label className="form-label mb-1 mt-0">Diet</label>
            <select
              name="diet"
              value={formData.diet}
              onChange={handleChange}
              className="form-control"
            >
              <option>Vegetarian</option>
              <option>Jain</option>
              <option>Non-Vegetarian</option>
              <option>Vegan</option>
              <option>Eggetarian</option>
            </select>
          </div>

          <div className="col-12">
            <button
              type="submit"
              className="btn btn-primary rounded-pill mt-2 px-5"
            >
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default UpdateProfile;
